import angular from 'angular';

import Component from './experience-schedule.component';

const Module = angular
    .module('control-room.commons.form.components.experience-schedule', [])
    .component('crExperienceSchedule', Component);

export default Module;
